<template>
  <v-app style="background-color:#FFFFFF;font-family: sfTextRegularFont;">
    <drawer ref="drawer" style="z-index:9999;" />
    <themeChanger v-if="this.$config.themeMutation" />
    <v-content ref="content">
      <virtual-list
        :size="56"
        :remain="domHeight / 56"
        :onscroll="scrollListener"
        :totop="topListener"
        ref="virtualList"
      >
        <v-btn
          v-show="fab"
          fab
          dark
          fixed
          bottom
          :right="topBtnAlign"
          color="rgba(0, 0, 0, 0.1)"
          @click="toTop"
        >
          <v-icon color="primary">mdi-chevron-up</v-icon>
        </v-btn>
        <v-card flat tile>
          <v-img :height="bgImgHeight" :src="backgroundImg">
            <v-card-text class="pt-0 pr-0 pl-0">
              <toolbar @listenChild="toolbarListener" />
              <explorer
                @listenChild="explorerListener"
                :class="textFieldUpDist"
              ></explorer>
            </v-card-text>
          </v-img>
        </v-card>
        <v-card flat v-if="isLoading" class="d-flex justify-center pt-10">
          <v-progress-circular
            :size="30"
            :width="3"
            color="primary"
            indeterminate
            class="py-12"
          />
        </v-card>
        <error v-else-if="showError" />
        <router-view ref="routerView" v-else />
      </virtual-list>
    </v-content>
  </v-app>
</template>
<script>
import explorer from "./views/Explorer";
import toolbar from "./components/material/Toolbar.vue";
import drawer from "./components/material/Drawer.vue";
import error from "./views/Error.vue";
import themeChanger from "./components/material/ThemeChanger.vue";
import virtualList from "vue-virtual-scroll-list";
import { mapState, mapMutations } from "vuex";
export default {
  name: "App",
  components: {
    virtualList,
    explorer,
    toolbar,
    drawer,
    error,
    themeChanger
  },
  metaInfo() {
    return {
      title: this.$config.alias,
      link: [
        {
          rel: "shortcut icon",
          href: this.$config.tokenIconUrl,
          type: "image/svg+xml"
        }
      ]
    };
  },
  data() {
    return {
      backgroundImg: require(`@/assets/themes/theme_${this.$config.theme}/img_homecard_bg.svg`),
      tokenInfo: null,
      bgImgHeight: 0,
      fab: false,
      isLoading: false,
      topBtnAlign: true,
      heightApis: {
        mainnet: "https://wallet.v.systems/api/blocks/height",
        testnet: "https://test.v.systems/api/blocks/height"
      },
      container: document.documentElement,
      domHeight: document.documentElement.clientHeight
    };
  },
  watch: {
    reloadPage(val) {
      this.isLoading = val;
      const that = this;
      if (val) {
        setTimeout(() => {
          that.updateReloadPage(false);
        }, 2 * 1000);
      }
    },
    theme(val) {
      this.backgroundImg = require(`@/assets/themes/theme_${val}/img_homecard_bg.svg`);
    },
    loadingData(val) {
      if (!this.$refs.routerView || !this.$refs.routerView.$el) {
        return;
      }
      const pageHeight =
        this.$refs.routerView.$el.clientHeight + Number(this.bgImgHeight);
      if (!val && pageHeight - 30 <= window.screen.height && this.hasMore) {
        this.updateToLoadMore(true);
      }
    }
  },
  computed: {
    ...mapState([
      "reloadPage",
      "showError",
      "toLoadMore",
      "hasMore",
      "loadingData",
      "theme"
    ]),
    textFieldUpDist() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "pt-0";
        case "sm":
          return "pt-10";
        case "md":
          return "pt-10";
        case "lg":
          return "pt-8 mt-6";
        case "xl":
          return "pt-8 mt-6";
        default: {
          return "pt-0";
        }
      }
    }
  },
  async created() {
    //
    this.bgImgHeight = this.imageHeight();
    this.getTopBtnAlign();
    // get node height
    const tokenId = this.$config.tokenId;
    this.updateTokenId(tokenId);
    let errorMsg = "Connection failed!Please check Internet connection.";
    try {
      this.txParams = { tokenId: this.tokenId };
      this.isLoading = true;
      const res = await this.$http.get(
        `${this.$config.apiEndPoint}/token/${this.$config.tokenId}`
      );
      if (res && res.data && res.data.result) {
        this.tokenInfo = Object.assign({}, this.tokenInfo, res.data.result);
        this.updateTokenInfo(this.tokenInfo);
      } else {
        errorMsg =
          res && res.data && !res.data.result
            ? "Cannot get information of this token, please check validation of token Id."
            : errorMsg;
        throw new Error("Error: Cannot get data from api.");
      }
    } catch (e) {
      this.updateShowError(true);
      if (e.response && e.response.status && e.response.status === 404) {
        errorMsg = "Token does not exist in db";
      } else if (e.code === "ECONNABORTED") {
        errorMsg =
          "Time out! Please check Internet connection or try again later.";
      }
      this.updateErrorMsg(errorMsg);
    }
    this.isLoading = false;
  },
  mounted() {
    let resizeId;
    window.addEventListener("resize", () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(this.bgImgHeightResize, 500);
    });
  },
  beforeDestroy() {
    let resizeId;
    window.removeEventListener("resize", () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(this.bgImgHeightResize, 500);
    });
  },
  methods: {
    ...mapMutations([
      "updateTokenId",
      "updateTokenInfo",
      "updateShowError",
      "updateErrorMsg",
      "updateTheme",
      "updateReloadPage",
      "updateCurBlockHeight",
      "updateToLoadMore"
    ]),
    topListener() {
      this.fab = false;
    },
    getTopBtnAlign() {
      // drawer keeps openning when screen size beyond md
      if (
        this.$vuetify.breakpoint.name !== "xs" &&
        this.$vuetify.breakpoint.name !== "sm" &&
        this.$vuetify.breakpoint.name !== "md"
      ) {
        this.topBtnAlign = false;
      } else {
        this.topBtnAlign = true;
      }
    },
    scrollListener() {
      if (!this.$refs.routerView || !this.$refs.routerView.$el) {
        return;
      }
      const pageHeight =
        this.$refs.routerView.$el.clientHeight + Number(this.bgImgHeight);
      const scrollTopLen = this.$refs.virtualList.$el.scrollTop;
      this.fab = scrollTopLen > 20;

      if (
        pageHeight - this.domHeight - scrollTopLen < 20 &&
        this.hasMore &&
        !this.loadingData
      ) {
        this.updateToLoadMore(true);
      }
    },
    bgImgHeightResize() {
      this.bgImgHeight = this.imageHeight();
      this.domHeight = document.documentElement.clientHeight;
      this.getTopBtnAlign();
    },
    imageHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "200";
        case "sm":
          return "250";
        case "md":
          return "250";
        case "lg":
          return "300";
        case "xl":
          return "300";
      }
    },
    toolbarListener(val) {
      if (val.goal === "ControlDrawer") {
        this.$refs.drawer.openDrawer();
      }
    },
    explorerListener(val) {
      if (val.goal === "SearchStart") {
        this.isLoading = true;
      } else if (val.goal === "SearchFinish") {
        this.isLoading = false;
      }
    },
    toTop() {
      this.$refs.virtualList.$el.scrollTop = 0;
    }
  }
};
</script>
<style>
@font-face {
  /* font-properties Text Regular*/
  font-family: sfTextRegularFont;
  src: url("assets/font/SF-Pro-Text-Regular.ttf");
}
</style>
>
